import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import onClickOutside from 'react-onclickoutside'

import Icon from './Icon'
import { BRAND_NISSAN } from '../config'
import ArrowDownIcon from '../svg/arrow-down'

class TopMenu extends Component {
  static propTypes = {
    links: PropTypes.array.isRequired,
    currentBrand: PropTypes.string
  }
  static defaultProps = {
    links: [],
    currentBrand: BRAND_NISSAN
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: false,
      showSubmenu: false
    }
  }

  handleTriggerClick = () => {
    this.setState({ opened: !this.state.opened })
  }

  // Method will be called by onClickOutside HOC
  handleClickOutside = () => {
    this.setState({ opened: false })
  }

  render() {
    const { links, currentBrand } = this.props

    if (!links.length) return null

    return (
      <div className={classNames("screen-topmenu", this.state.opened && "opened")}>
        <button title='topmenu-trigger' className="topmenu-trigger" onClick={this.handleTriggerClick}><Icon type="dots" /></button>
        <ul className="topmenu-inner">
          {this.props.links?.filter(item => item?.title == "Seleccionar vehículo")?.map((link, i) => {
            if (link.url) return <li key={i}><Link className="topmenu-link" to={link.url}>{link.title}</Link></li>

            return <li key={i}><button className="topmenu-link" onClick={link.onClick ? link.onClick : null}>{link.title}</button></li>
          })}
          <li>
            <div
              onMouseEnter={() => this.setState({ showSubmenu: true })}
              onMouseLeave={() => this.setState({ showSubmenu: false })}
              style={{ position: 'relative', display: 'inline-block' }}
            >
              <div
                className="topmenu-link parent-menu-sm"
                onClick={() => this.setState({ showSubmenu: !this.state.showSubmenu })}
              >
                Legales
                <span style={{
                  transition: "transform 0.5s ease",
                  transform: this.state.showSubmenu ? "rotate(180deg)" : "rotate(0deg)",
                }}>
                  <ArrowDownIcon height='10px' width='10px' fill='#ffff' />
                </span>
              </div>
              <div className="topmenu-link parent-menu">
                Legales
              </div>
              {
                this.state.showSubmenu &&
                <div className='sub-menu-sm'>
                  <a className='topmenu-link'
                    target="_blank"
                    rel="noopener noreferrer"
                    href={currentBrand === BRAND_NISSAN ? "https://www.nissan.com.mx/content/dam/Nissan/mexico/avisos-de-privacidad/nissan-2024-avisos_de_privacidad-clientes_y_prospectos.pdf" : "https://www.infiniti.mx/aviso-privacidad.html"}>
                    Aviso de privacidad
                  </a>
                  <a className='topmenu-link'
                    target="_blank"
                    rel="noopener noreferrer"
                    href={currentBrand === BRAND_NISSAN ? "https://www.nissan.com.mx/legales/legales/legales_nissan_mexicana.html" : "https://www.infiniti.mx/legales.html "}>
                    Legales de sitio
                  </a>
                </div>
              }
              {this.state.showSubmenu &&
                <div
                  className='sub-menu'
                >
                  <a className='topmenu-link sub-menu-link'
                    target="_blank"
                    rel="noopener noreferrer"
                    href={currentBrand === BRAND_NISSAN ? "https://www.nissan.com.mx/content/dam/Nissan/mexico/avisos-de-privacidad/nissan-2024-avisos_de_privacidad-clientes_y_prospectos.pdf" : "https://www.infiniti.mx/aviso-privacidad.html"}>
                    Aviso de privacidad
                  </a>
                  <a className='topmenu-link sub-menu-link'
                    target="_blank"
                    rel="noopener noreferrer"
                    href={currentBrand === BRAND_NISSAN ? "https://www.nissan.com.mx/legales/legales/legales_nissan_mexicana.html" : "https://www.infiniti.mx/legales.html "}>
                    Legales de sitio
                  </a>
                </div>}
            </div>
          </li>
        </ul>
      </div>
    )
  }
}


export default onClickOutside(TopMenu)
